import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, take } from 'rxjs';

/**
 * Blocks routes until Cognito has authenticated the user, sending them to the hosted login when
 * they are not. This is a convenience for the browser only — the API enforces authentication and
 * roles independently, so a user who bypasses this gets 401s rather than access.
 */
export const authGuard: CanActivateFn = () => {
  const oidc = inject(OidcSecurityService);
  return oidc.isAuthenticated$.pipe(
    take(1),
    map(({ isAuthenticated }) => {
      if (isAuthenticated) return true;
      oidc.authorize();      // redirect to the Cognito hosted login
      return false;
    })
  );
};
